
export interface AISettings {
    enableOnline: boolean;
    personaText: string;
    authorVoiceDefault: boolean;
}

const STORAGE_KEY = 'verseflip.aiSettings.v1';

const DEFAULT_AI_SETTINGS: AISettings = {
    enableOnline: true,
    personaText: '', // Now treated as "personaAddon" to the core persona
    authorVoiceDefault: false,
};

export function loadAISettings(): AISettings {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw) return { ...DEFAULT_AI_SETTINGS, ...JSON.parse(raw) };
    } catch (e) {
        console.error('Failed to load AI settings', e);
    }
    return DEFAULT_AI_SETTINGS;
}

export function saveAISettings(settings: AISettings) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
}
